/*'http://localhost:3001/'
Is the local host used to simulate a server locally using json-server.*/
//export const baseUrl = 'http://localhost:8080/';
export const baseUrl = 'https://us-central1-edjserver.cloudfunctions.net/edjServer/';
export const bibleUrl = 'https://ajphchgh0i.execute-api.us-west-2.amazonaws.com/dev/';